import Api from 'api';

import {
  GET_ACCOUNTS,
  SET_ACCOUNTS_PAGINATION,
  SET_ACCOUNTS_FILTERS,
  RESET_ACCOUNTS,
  TOGGLE_ACCOUNT,
  ADD_ACCOUNT,
  UPDATE_ACCOUNT,
  GET_ACCOUNT_BY_ID,
  RESET_ACCOUNT_FORM,
  GET_ACCOUNT_FORM_CONFIG,
  MODIFY_EDITING_ACCOUNT,
  MODIFY_CUSTOM_FIELD_EDITING_ACCOUNT, //Groups
  ADD_CUSTOM_FIELD_EDITING_ACCOUNT,
  REMOVE_CUSTOM_FIELD_EDITING_ACCOUNT,
  UPDATE_SELF_ACCOUNT,
} from 'accounts/constants';

import { SET_LISTS } from 'containers/lists/constants';

export const setPagination = (payload) => ({
  type: SET_ACCOUNTS_PAGINATION,
  payload,
});

export const setFilters = (payload) => ({
  type: SET_ACCOUNTS_FILTERS,
  payload,
});

export const getAccounts = (companyId, subcompanyId, filters, limit, page, orderBy, order) => ({
  type: GET_ACCOUNTS,
  meta: { needAuth: true },
  payload: Api.accounts.get(companyId, subcompanyId, filters, limit, page, orderBy, order),
});

export const reset = () => ({ type: RESET_ACCOUNTS });

export const toggle = (accountId, companyId, subcompanyId) => ({
  type: TOGGLE_ACCOUNT,
  meta: { id: accountId, needAuth: true },
  payload: Api.accounts.toggle(accountId, companyId, subcompanyId),
});

export const resetForm = () => ({ type: RESET_ACCOUNT_FORM });

export const getAccountById = (accountId, companyId, subcompanyId) => ({
  type: GET_ACCOUNT_BY_ID,
  meta: { needAuth: true },
  payload: Api.accounts.getById(accountId, companyId, subcompanyId),
});

export const getFormConfig = (companyId, subcompanyId) => (dispatch) =>
  dispatch({
    type: GET_ACCOUNT_FORM_CONFIG,
    meta: { needAuth: true },
    payload: Api.accounts.formConfig(companyId, subcompanyId),
  }).then(({ value: { accounts, depreciations } }) => {
    dispatch({
      type: SET_LISTS,
      payload: {
        accounts,
        depreciations,
      },
    });
  });

export const modifyAccount = (payload) => ({ type: MODIFY_EDITING_ACCOUNT, payload });

//Groups
export const modifyCustomField = (payload) => ({
  type: MODIFY_CUSTOM_FIELD_EDITING_ACCOUNT,
  payload,
}); // Agregado

export const addAccount = (companyId, subcompanyId, account) => ({
  type: ADD_ACCOUNT,
  payload: Api.accounts.add(companyId, subcompanyId, account),
});

export const updateAccount = (accountId, companyId, subcompanyId, account) => ({
  type: UPDATE_ACCOUNT,
  meta: { id: accountId, needAuth: true },
  payload: Api.accounts.update(accountId, companyId, subcompanyId, account),
});

export const updateSelfAccount = (account) => {
  console.log(account);
  // return ({
  // type: UPDATE_SELF_ACCOUNT,
  // meta: { needAuth: true },
  // payload: Api.auth.updateInfo(
  //   account
  // )
  //   }
  // )
};

/*
{
	"name": "prueba cambio",
	"lastname": "pruba 2",
	"password":	"admin12345"
}
*/

export const addCustomField = () => ({ type: ADD_CUSTOM_FIELD_EDITING_ACCOUNT });

export const removeCustomField = (index) => ({
  type: REMOVE_CUSTOM_FIELD_EDITING_ACCOUNT,
  payload: index,
});



// WEBPACK FOOTER //
// src/modules/secured/modules/accounts/actions/accounts_actions.js